/** @jsxImportSource @emotion/react */
import React from 'react';
import { Header } from '../chat/header/header';
import { AudioPlayer } from './question/components/audio-player';

import {
  OnboardingContainer,
  OnboardingWelcomeContainer,
  OnboardingWelcomeText,
  Main,
} from './styles';

export const Onboarding: React.FC = () => {
  const audioUrl = '/audio/Chris_WelcomeMessage.wav';

  return (
    <OnboardingContainer>
      <Header
        onNotificationClick={() => {}}
        onProfileClick={() => {}}
      ></Header>

      <Main>
        <div style={{ width: '215px', marginBottom: '32px', placeSelf: 'center' }} >
        <img src="/main-logo-white.svg" alt="Mailander Logo" style={{ width: "100%", height: "100%" }} />
        </div>
        <OnboardingWelcomeContainer>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '38px'  }}>
            <AudioPlayer audioUrl={audioUrl} />
          </div>
          <OnboardingWelcomeText>
            Hi, great to have you. This is going to be fun! Now that you are registered, look for a
            message from me in the next 24 hours. I'm going to set you up for onboarding.
            <br />
            <br />
            Just follow the instructions when my message comes through, and we'll go from there.
            Talk soon.
          </OnboardingWelcomeText>
        </OnboardingWelcomeContainer>
      </Main>

    </OnboardingContainer>
  );
};
